import { z } from 'zod';
import { LpInvestorUpdateStatus } from 'further-types/lp/investor-update';
import {
  BulletinRecipientTarget,
  BulletinDeliveryMethod,
  BulletinAttachmentMode,
} from 'further-types/lp/bulletin-update';
import { blockNoteDocumentSchema } from '../../common/block-note-editor';
import { isMongoId } from '../../helpers';

const BulletinUpdateBase = z.object({
  vehicleId: z.string().refine(isMongoId()),
  status: z.nativeEnum(LpInvestorUpdateStatus),
  recipientTarget: z.nativeEnum(BulletinRecipientTarget),
  investorIds: z.array(z.string().refine(isMongoId())),
  deliveryMethod: z.nativeEnum(BulletinDeliveryMethod),
  attachmentMode: z.nativeEnum(BulletinAttachmentMode),
  includeUkFinancialPromotionsNotice: z.boolean(),
});

export const SaveBulletinUpdate = BulletinUpdateBase.extend({
  id: z.string().refine(isMongoId()).optional(),
  subject: z.string(),
  title: z.string(),
  commentary: blockNoteDocumentSchema,
  attachments: z.array(
    z.object({
      name: z.string(),
      path: z.string(),
      assignedInvestorIds: z.array(z.string().refine(isMongoId())),
    }),
  ),
  resendPublishedUpdates: z.boolean(),
});

export const PublishBulletinUpdate = SaveBulletinUpdate.extend({
  subject: z.string().min(1, 'Subject line is required.'),
  title: z.string().min(1, 'Body title is required.'),
  commentary: blockNoteDocumentSchema.min(1, 'Body text is required.'),
}).superRefine((data, ctx) => {
  if (
    data.recipientTarget === BulletinRecipientTarget.SelectedInvestors &&
    data.investorIds.length === 0
  ) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['investorIds'],
      message: 'Select at least one investor.',
    });
  }
});
